import { PERMISSION_KEYS } from 'constants-permissions';
import { ALL_ACTIONS, READ_ONLY_ACTIONS } from '../Action';
import {
  hasAnyPermission,
  isAssigneeOrTeamMember,
  isOwner,
  isSuperUser,
} from '../predicates';
import type { PreventiveMaintenanceResource } from '../Resource';
import { evaluateRules, type AccessRequest, type Rule } from '../Rule';

export const PM_SCHEDULE_RULES: readonly Rule<PreventiveMaintenanceResource>[] =
  [
    { name: 'superuser', actions: ALL_ACTIONS, appliesTo: isSuperUser },
    {
      name: 'admin',
      actions: ALL_ACTIONS,
      appliesTo: hasAnyPermission([PERMISSION_KEYS.PERMISSION_ADMIN]),
    },
    { name: 'owner', actions: ALL_ACTIONS, appliesTo: isOwner },
    // PM schedules have no attach permission of their own
    {
      name: 'attach-file',
      actions: ALL_ACTIONS,
      appliesTo: hasAnyPermission([
        PERMISSION_KEYS.PERMISSION_WORK_ORDERS_PM_TASK_ATTACH_FILE,
      ]),
    },
    // Task viewers keep seeing a schedule's files on the mobile task screen
    {
      name: 'view-all',
      actions: READ_ONLY_ACTIONS,
      appliesTo: hasAnyPermission([
        PERMISSION_KEYS.PERMISSION_WORK_ORDERS_PM_SCHEDULE_VIEW,
        PERMISSION_KEYS.PERMISSION_WORK_ORDERS_PM_TASK_VIEW,
      ]),
    },
    {
      name: 'assignee-team',
      actions: READ_ONLY_ACTIONS,
      appliesTo: isAssigneeOrTeamMember,
    },
  ];

export const canAccessPmScheduleAttachment = (
  request: AccessRequest<PreventiveMaintenanceResource>
): boolean => evaluateRules(PM_SCHEDULE_RULES, request);
